export const ON_COLOR_SETTINGS = {
  AUTO: 'auto',
  DARK: 'dark',
  LIGHT: 'light',
};
